export default function () {
  const widgetName = "tier1MainFeatureSeo";
  const widgetOpts = tier1MainFeatureSeoOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    buyNowButton: false,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    moreButton: false,
    textOverImage: false,
    link: [""],
    cardWidgetLoaded: function (data) {
      const widgetData = data.items;
      if (widgetData.length < 1) {
        $(`#${widgetName}`).remove();
      } else {
        customMainSeoFeature(widgetData);
      }
    },
  });

  function customMainSeoFeature(widgetData) {
    const { Description } = widgetData[0];

    $(`#${widgetName} .card-widget-item`).replaceWith(
      `<p class="main-feature-seo">${Description}</p>`
    );
  }
}
